import * as React from 'react';
import { useNavigate } from 'react-router';
import { INTERNAL_SUPPORTED_EVENTS } from '~/common/helpers';

export const usePluginNavigateListener = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const handleNavigate = (event: Event) => {
      const { path } = (event as CustomEvent<{ path: string }>).detail;
      void navigate(path);
    };

    window.addEventListener(INTERNAL_SUPPORTED_EVENTS.NAVIGATE, handleNavigate);

    return () => {
      window.removeEventListener(
        INTERNAL_SUPPORTED_EVENTS.NAVIGATE,
        handleNavigate,
      );
    };
  }, [navigate]);
};
